import { createRoute, redirect } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { PublicVideosPage } from "@/features/public-videos";
import { authClient } from "@/lib/auth";

export const publicRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/public",
  beforeLoad: async () => {
    const { data } = await authClient.getSession();
    if (!data) {
      throw redirect({ to: "/login", search: { redirect: "/public" } });
    }
  },
  component: PublicVideosPage,
});
